import $ from 'jquery';
import '../../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox';

// carousel campus form entry
function initCarouselCampusForm() {
  var carouselCampusFormEl = document.getElementById('jsCampusFormCarousel');
  if (carouselCampusFormEl != null) {
    var carouselCampusForm = new Swiper('#jsCampusFormCarousel .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1,
      pagination: {
        el: '.jsPag',
        clickable: true,
      },
      navigation: {
        nextEl: '#jsCampusFormCarousel .jsNext',
        prevEl: '#jsCampusFormCarousel .jsPrev',
      },
      autoplay: false,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: false,
        }
      },
    });

  }
}

function openPopup() {
  $.fancybox.close();
  $(document).on('click', '.jsCallPopupDetail', function(e) {
    var _popup = $(this).attr('href'),
      _idVid = $(this).data('id'),
      _contentLink = $(this).parent().find('.ttlModal').text(),
      _caption = $(this).parent().find('.txt01Modal').text(),
      _tag = $(this).parent().find('.tagModal').text(),
      _school = $(this).parent().find('.schoolModalSlug').text();
    // e.preventDefault();
    $.fancybox.open({
      src: _popup,
      category: "inline",
      closeExisting: false,
      opts: {
        touch: false,
        afterLoad: function() {
          initCarouselCampusForm();
        },
        beforeShow: function(instance, current) {
          $("html").css({
            overflow: "hidden"
          });
          var res = _tag.split("#");
          res.splice(0, 1);
          $.each(res, function(index, item) {
            var li = document.createElement('li');
            var link = document.createElement("a");
            link.setAttribute('href', '/' + _school + '/movielist/' + item);
            li.appendChild(link);
            link.appendChild(document.createTextNode('#' + item));
            $(_popup).find('.cardCurriculum .tagList01').append(li);
          });
          $(_popup).find('#videoBox').append('<iframe src="https://www.youtube.com/embed/' + _idVid + '?rel=0&showinfo=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
          $(_popup).find('.vidAbroad').append('<iframe src="https://tigmedia.jp/watch?id=' + _idVid + '&help=true" allowfullscreen></iframe>');
          $(_popup).find('.cardCurriculum .ttl').append(document.createTextNode(_contentLink));
          $(_popup).find('.cardCurriculum .txt01').append(document.createTextNode(_caption));
        },
        beforeClose: function(instance, current) {
          $("html").css({
            "overflow-y": "auto"
          });
          $(_popup).find('#videoBox').empty();
          $(_popup).find('.cardCurriculum .ttl').empty();
          $(_popup).find('.cardCurriculum .txt01').empty();
          $(_popup).find('.cardCurriculum .tagLink').empty();
          $(_popup).find('.cardCurriculum .tagList01').empty();
        }
      }
    });
  });

  $('.jsPopupDetailClose').on('click', function(e) {
    $.fancybox.close();
    if ($('.jsModalSlide').length) {
      $(".jsModalSlide form nav a").first().addClass("current");
    }
  });
}

function openLinkSp() {
  if ($('.jsOpenLinkSp').length) {
    if ($(window).width() < 768) {
      var _dataHref = $('.jsOpenLinkSp').data('id'),
        hrefNew = 'https://tigmedia.jp/watch?id=' + _dataHref + '&help=true&controls=footer';
      $('.jsOpenLinkSp').attr('href', hrefNew).attr("target", "_blank").removeClass('jsCallPopupDetail');
    } else {
      $('.jsOpenLinkSp').attr('href', '#popupDetail01').attr("target", "").addClass('jsCallPopupDetail');
    }
  }
}

function checkedRadioSchool() {
  if ($('.jsCheckedSchool').length) {
    $('.jsCheckedSchool').on('change', function() {
      $(this).each(function() {
        if ($(this).prop("checked")) {
          $.fancybox.close();
        }
      });
    })
  }
}

//window event
window.addEventListener('load', function(e) {
  openPopup();
  checkedRadioSchool();
  openLinkSp();
});

window.addEventListener('resize', function(e) {
  openLinkSp();
});